
import { Menu, MenuItem, Typography } from '@mui/material'
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import TestListAddTestsIcon from '../../assets/iconComponents/TestListAddTestsIcon'
import TestListAddFolderIcon from '../../assets/iconComponents/TestListAddFolderIcon'
import TestListCreateCycleIcon from '../../assets/iconComponents/TestListCreateCycleIcon'

const TestsHierarchicalListDropdown = ({
  anchorEl,
  open,
  dropdownElInfo,
  handleMenuClose,
  handleRegenerateTests,
  handleEditVersionModalOpen,
  handleDeleteVersionModalOpen,
  handleCreateCycleModalOpen,
  handleEditCycleModalOpen,
  handleDeleteCycleModalOpen,
  handleCreateFolderModalOpen,
  handleEditFolderModalOpen,
  handleDeleteFolderModalOpen,
  handleAddTestsModalOpen,
  handleEditTestCaseModalOpen,
  handleDeleteTestCaseModalOpen
}) => {
  return (
    <Menu
      className="testsHierarchicalListDropdownMenu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {dropdownElInfo.isBlueprint && dropdownElInfo.class === 'folder'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleRegenerateTests}>
          <RefreshOutlinedIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Regenerate Tests
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.isBlueprint || (dropdownElInfo.class === 'version' && !dropdownElInfo.isBlueprint)
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={() => handleCreateCycleModalOpen()}>
          <TestListCreateCycleIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Create Cycle
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'version' && !dropdownElInfo.isBlueprint
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleEditVersionModalOpen}>
          <EditOutlinedIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Edit Version
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'cycle' && !dropdownElInfo.isBlueprint
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleAddTestsModalOpen}>
          <TestListAddTestsIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Add Tests
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'cycle'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleCreateFolderModalOpen}>
          <TestListAddFolderIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Add Folder
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'cycle'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleEditCycleModalOpen}>
          <EditOutlinedIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Edit Cycle
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'folder' && !dropdownElInfo.isBlueprint && !dropdownElInfo.cycleId
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleEditFolderModalOpen}>
          <EditOutlinedIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Edit Folder
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'testCase'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleEditTestCaseModalOpen}>
          <EditOutlinedIcon />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle">
            Edit Test Case
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'version' && !dropdownElInfo.isBlueprint
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleDeleteVersionModalOpen}>
          <DeleteOutlineOutlinedIcon color='error' />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle deleteItemTitle">
            Delete Version
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'cycle'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleDeleteCycleModalOpen}>
          <DeleteOutlineOutlinedIcon color='error' />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle deleteItemTitle">
            Delete Cycle
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'folder' && !dropdownElInfo.isBlueprint
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleDeleteFolderModalOpen}>
          <DeleteOutlineOutlinedIcon color='error' />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle deleteItemTitle">
            Delete Folder
          </Typography>
        </MenuItem>
        : null
      }
      {dropdownElInfo.class === 'testCase'
        ? <MenuItem className="testsHierarchicalListDropdownMenuItemContainer" onClick={handleDeleteTestCaseModalOpen}>
          <DeleteOutlineOutlinedIcon color='error' />
          <Typography className="testsHierarchicalListDropdownMenuItemTitle deleteItemTitle">
            Delete Test Case
          </Typography>
        </MenuItem>
        : null
      }
    </Menu>
  )
}

export default TestsHierarchicalListDropdown
